import {
  Box,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  VStack,
} from "@chakra-ui/react";
import { BaseBlockProps, UIBlock } from "./types";

interface AccordionContent {
  title?: string;
  children?: UIBlock[];
}

// Forward declaration - will be imported from index to avoid circular deps
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let BlockRenderer: any = null;

export const setBlockRenderer = (renderer: typeof BlockRenderer) => {
  BlockRenderer = renderer;
};

export const AccordionBlock = ({ block }: BaseBlockProps) => {
  const content = block.content as AccordionContent | string | undefined;

  const title =
    typeof content === "object" ? content?.title : block.title || "Details";
  const children = typeof content === "object" ? content?.children : undefined;

  return (
    <Accordion allowToggle>
      <AccordionItem
        border="1px solid"
        borderColor="border.default"
        borderRadius="component.md"
        overflow="hidden"
      >
        <h2>
          <AccordionButton py="sm" _hover={{ bg: "neutral.50" }}>
            <Box flex="1" textAlign="left">
              <Text fontSize="sm" fontWeight="600" color="text.body.primary">
                {title}
              </Text>
            </Box>
            <AccordionIcon color="text.body.secondary" />
          </AccordionButton>
        </h2>
        <AccordionPanel pb="md" pt={0}>
          <Box borderTop="1px solid" borderColor="border.default" pt="md">
            {children && children.length > 0 && BlockRenderer ? (
              <VStack align="stretch" spacing="sm">
                {children.map((childBlock, i) => (
                  <BlockRenderer key={childBlock.id || i} block={childBlock} />
                ))}
              </VStack>
            ) : (
              <Text fontSize="xs" color="text.body.tertiary">
                No content
              </Text>
            )}
          </Box>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
